import { showAlert } from 'actions/client';
import CenteredSpinner from 'components/Utility/CenteredSpinner';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  CreateGroupAPIRequest,
  DeleteGroupsAPIRequest,
  FetchAllGroupsAPIRequest,
  UpdateGroupsAPIRequest,
} from 'utils/constants/network';
import { callAPI } from 'utils/network';
import AddButton from '../MenuEditor/components/shared/AddButton';
import { PATH_KEY_TO_POSITION } from '../MenuEditor/constants';
import GroupDetails from './components/GroupDetails';
import GroupEditor from './components/GroupEditor';
import { DISPLAY_MODE } from './constants';
import './index.scss';

const LEVEL = PATH_KEY_TO_POSITION['menuIdx'];

const Beta = styled.span`
  float: right;
  width: 44px;
  height: 19px;
  background: #2d235f;
  border-radius: 43px;
  font-family: Basier Circle;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 19px;
  text-align: center;
  letter-spacing: -0.2px;
  color: #e6d6fa;
  margin-left: 10px;
  margin-top: 8px;
`;

const Code = styled.span`
  position: absolute;
  width: 127px;
  height: 46px;
  line-height: 42px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  border-radius: 75px;

  @media (max-width: 900px) {
    width: 110px;
    display: flex;
    justify-content: center;
    position: relative;
  }
`;
const SectionContainer = styled.div`
  margin-top: 18px;
  max-width: 1120px;
  background: #ffffff;
  ${({ displayShadow }) =>
    displayShadow &&
    `border: 1px solid #eeeeee;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);`}

  @media (max-width: 360px) {
    display: flex;
    width: 100%;
    flex-direction: column;
  }

  @media (max-width: 900px) {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
  @media only screen and (min-device-width: 1024px) and (max-device-height: 1366px) {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
`;
const AddButtonContainers = styled.div`
  padding: 30px 30px 20px 30px;
  margin-bottom: 50px;

  @media (max-width: 900px) {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 30px;
  }
`;
const AddButtonContainer = styled.div`
  padding: 30px 30px 20px 30px;

  @media (max-width: 900px) {
    display: flex;
    justify-content: flex-start;
  }
`;
const SpanTitle = styled.div`
  margin-left: 30px;
  margin-top: 30px;
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: #000000;
`;

const SpanDesc = styled.div`
  width: 378px;
  height: 22px;
  margin-left: 30px;
  margin-top: 8px;
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: -0.2px;
  color: #000000;

  @media (max-width: 900px) {
    width: 90%;
    margin-bottom: 16px;
  }
`;

class MultiVenuePanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cloneStripe: false,
      cloneMenu: false,
      showGroupEditor: false,
      groups: [],
      fetchingGroups: false,
      creatingGroup: false,
      expandedIds: [],
      displayMode: DISPLAY_MODE.list,
      groupIdToEdit: null,
      deletingGroup: false,
      editingGroup: false,
    };
  }

  async fetchAllGroups() {
    this.setState({ fetchingGroups: true });

    try {
      const apiRequest = FetchAllGroupsAPIRequest({});
      const allGroups = await callAPI(apiRequest);
      const groups = allGroups.reverse().map(group => {
        return {
          ...group,
          participants: group.expandedParticipants.map(
            ({ name, url_slug, image_url, participant_id }) => {
              return {
                participantId: participant_id,
                name: name,
                slug: url_slug,
                imageUrl: image_url,
              };
            }
          ),
        };
      });

      this.setState({
        groups,
      });
    } catch (e) {
      console.error(e);
      this.props.showAlert('Failure', 'Sorry, we could not fetch your Groups.');
    } finally {
      this.setState({ fetchingGroups: false });
    }
  }

  async createNewGroup(data) {
    this.setState({ creatingGroup: true });

    try {
      const apiRequest = CreateGroupAPIRequest(data);
      const newGroup = await callAPI(apiRequest);

      const newIds = [...this.state.expandedIds, newGroup._id];

      this.props.showAlert(
        'Success',
        `${newGroup.name} has been successfully created.`
      );
      this.setState({
        groups: [...this.state.groups, newGroup],
        updatedGroupId: newGroup._id,
        expandedIds: newIds,
      });
    } catch (e) {
      console.error(e);
      this.props.showAlert(
        'Failure',
        'Sorry, we could not create a new Group.'
      );
    } finally {
      this.fetchAllGroups();
      this.setState({
        creatingGroup: false,
        showGroupEditor: false,
        displayMode: DISPLAY_MODE.list,
      });
    }
  }

  async deleteGroup(group) {
    try {
      const apiRequest = DeleteGroupsAPIRequest({ id: group._id });
      await callAPI(apiRequest);

      this.setState({ deletingGroup: true });
      this.props.showAlert(
        'Multivenue Deleted',
        `${group.name} has been successfully deleted.`
      );
    } catch (e) {
      console.error(e);
      this.props.showAlert('Failure', 'Sorry, we could not delete your Group.');
    } finally {
      this.fetchAllGroups();
      this.setState({
        updatedGroupId: null,
        deletingGroup: false,
        showGroupEditor: false,
        displayMode: DISPLAY_MODE.list,
      });
    }
  }

  async updateGroup(data) {
    this.setState({ editingGroup: true });

    const groupId = data._id;
    const dataObj = { ...data };
    delete dataObj['_id'];

    const payload = {
      id: groupId,
      changes: dataObj,
    };

    try {
      const apiRequest = UpdateGroupsAPIRequest(payload);
      const edittedGroup = await callAPI(apiRequest);

      const edittedIds = [...this.state.expandedIds, edittedGroup._id];

      this.props.showAlert(
        'Success',
        `${edittedGroup.name} has been successfully edited.`
      );
      this.setState({
        expandedIds: edittedIds,
      });
    } catch (e) {
      console.error(e);
      this.props.showAlert('Failure', 'Sorry, we could not edit your group.');
    } finally {
      this.fetchAllGroups();
      this.setState({
        updatedGroupId: payload.id,
        editingGroup: false,
        showGroupEditor: false,
        displayMode: DISPLAY_MODE.list,
      });
    }
  }

  // Lifecycle
  componentWillMount() {
    this.fetchAllGroups();
  }

  componentWillUpdate(nextProps) {
    if (!nextProps.creatingVenue && this.props.creatingVenue) {
      if (nextProps.venueCreated) {
        this.showVenueCreated();
      } else {
        this.showVenueError();
      }
    }
  }

  addNewGroup() {
    this.setState({
      showGroupEditor: true,
      displayMode: DISPLAY_MODE.create,
    });
  }

  switchToEditMode(groupId) {
    this.setState({
      displayMode: DISPLAY_MODE.edit,
      groupIdToEdit: groupId,
      showGroupEditor: true,
    });
    document.getElementsByClassName('content__container')[0].scrollTo(0, 0);
  }

  render() {
    const {
      groups,
      fetchingGroups,
      showGroupEditor,
      creatingGroup,
      displayMode,
      groupIdToEdit,
      editingGroup,
      deletingGroup,
      updatedGroupId,
    } = this.state;

    const loading = fetchingGroups;
    const displayCreateMultiVenueBar =
      (displayMode === DISPLAY_MODE.list && groups.length === 0) ||
      [DISPLAY_MODE.edit, DISPLAY_MODE.create].includes(displayMode);

    if (loading) {
      return (
        <div className="panel__content create__venue__container">
          <h3 className="panel__title">
            Multi-Venue <Beta>BETA</Beta>
          </h3>
          <SectionContainer displayShadow={true}>
            <CenteredSpinner />
          </SectionContainer>
        </div>
      );
    }

    return (
      <div className="panel__content create__venue__container">
        <h3 className="panel__title">
          Multi-Venue <Beta>BETA</Beta>
        </h3>

        {showGroupEditor && (
          <SectionContainer displayShadow={displayCreateMultiVenueBar}>
            <GroupEditor
              loading={creatingGroup || editingGroup || deletingGroup}
              onSave={data => {
                if (displayMode === DISPLAY_MODE.create) {
                  this.createNewGroup(data);
                } else {
                  this.updateGroup(data);
                }
              }}
              onCancel={() =>
                this.setState({
                  showGroupEditor: false,
                  displayMode: DISPLAY_MODE.list,
                })
              }
              displayMode={displayMode}
              group={groups.find(group => group._id === groupIdToEdit)}
              onDelete={group => this.deleteGroup(group)}
              showAlert={this.props.showAlert}
            />
          </SectionContainer>
        )}

        {Boolean(displayMode === DISPLAY_MODE.list && groups.length === 0) && (
          <SectionContainer
            displayShadow={displayCreateMultiVenueBar}
            style={{ marginBottom: -10 }}
          >
            <AddButtonContainer level={LEVEL} style={{ marginBottom: 10 }}>
              <AddButton onClick={() => this.addNewGroup()}>
                Create a multi-venue
              </AddButton>
            </AddButtonContainer>
          </SectionContainer>
        )}

        {Boolean(displayMode === DISPLAY_MODE.list) && (
          <SectionContainer style={{ marginTop: 10 }}>
            {!loading &&
              groups.map(group => {
                return (
                  <GroupDetails
                    key={group._id}
                    group={group}
                    updatedGroupId={updatedGroupId}
                    switchToEditMode={groupId => this.switchToEditMode(groupId)}
                    venueId={this.props.venue._id}
                  />
                );
              })}
          </SectionContainer>
        )}

        <SectionContainer displayShadow={true} style={{ marginTop: 10 }}>
          <SpanTitle>Your Venue ID</SpanTitle>
          <SpanDesc>Share your Venue ID below to join a multi-venue.</SpanDesc>
          <AddButtonContainers style={{ marginTop: -13 }} level={LEVEL}>
            <Code>{this.props.venue.participant_id}</Code>
          </AddButtonContainers>
        </SectionContainer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  venue: state.venue,
});

const mapDispatchToProps = dispatch => ({
  showAlert: (title, message) => dispatch(showAlert(title, message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MultiVenuePanel);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MultiVenue/index.jsx